var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewUiCalloutIcon',{staticClass:"view-ui-state-nofavorites",attrs:{"iconFilename":"heart-fill.svg","message":'Your favorite venues<br />will appear here'}})
}
var staticRenderFns = []

export { render, staticRenderFns }